import { useCallback, useMemo, useState } from 'react';
import ScoringApiClient from './scoring-api-client';

export default function useScoringDashboardLoader({
                                                    api,
                                                    onError,
                                                    onResponse = null
                                                  }) {
  if (!api) {
    throw new Error('api (instance of Api class) is required');
  }

  if (!onError || typeof onError !== 'function') {
    throw new Error('onError is a required argument and must be a function');
  }

  const scoringApiClient = useMemo(() => new ScoringApiClient(api), [api]);

  const [loadingScore, setLoadingScore] = useState(true);
  const [dashboardData, setDashboardData] = useState([]);

  const getDashboard = useCallback((getEventDashboardArgs) => {
    setLoadingScore(true);

    // Abort current/pending requests if getEventDashboard args change
    scoringApiClient.abortCurrentRequest();

    return scoringApiClient.getEventDashboard(getEventDashboardArgs)
      .then(resp => {
        setDashboardData(resp.teams);
        if (onResponse) {
          onResponse(resp);
        }
        setLoadingScore(false);
      })
      .catch(onError)
  }, [scoringApiClient, onError, onResponse]);

  return { loadingScore, dashboardData, getDashboard };
}